export const TEMPLATE_OPEN_MODAL = "TEMPLATE_OPEN_MODAL";
export const TEMPLATE_CREATE_REQUEST = "TEMPLATE_CREATE_REQUEST";
export const TEMPLATE_CREATE_RESULT = "TEMPLATE_CREATE_RESULT";
export const TEMPLATE_UPDATE_REQUEST = "TEMPLATE_UPDATE_REQUEST";
export const TEMPLATE_UPDATE_RESULT = "TEMPLATE_UPDATE_RESULT";
export const TEMPLATE_SEARCH_REQUEST = "TEMPLATE_SEARCH_REQUEST";
export const TEMPLATE_SEARCH_RESULT = "TEMPLATE_SEARCH_RESULT";
export const TEMPLATE_GET_REQUEST = "TEMPLATE_GET_REQUEST";
export const TEMPLATE_GET_RESULT = "TEMPLATE_GET_RESULT";
